import React, { useState, useEffect } from "react";

//package import

import {
  Dialog,
  DialogTitle,
  IconButton,
  DialogContent,
  Typography,
  Button,
  Grid,
  TextField,
  Box,
  useTheme,
  Snackbar,
  CircularProgress,
  Backdrop,
  Alert,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { Close as CloseIcon } from "@mui/icons-material";
import { Form, Formik } from "formik";
import { formControlClasses } from "@mui/material/FormControl";
import { outlinedInputClasses } from "@mui/material/OutlinedInput";

//user import

import { headersPost } from "../../../../Services/API";
import { MINISTRY_API_ULRS } from "../../../../Services/Routes/API";
import { RoutesUrls } from "../../../../Services/Routes/APP";
import { phoneSchema } from "../../../../Services/validations/AdminPortal/updateUser";

//constants

const initialValue = {
  phone_number: "",
};

//component

const EditPhoneModal = ({ open, closeHandler, user }) => {
  //hooks

  const theme = useTheme();
  const navigate = useNavigate();

  //states

  const [loader, setLoader] = useState(false);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMsg, setAlertMsg] = useState("");
  const [alertIcon, setAlertIcon] = useState("error");
  const [formValues, setFormValues] = useState(initialValue);

  //form submit handler

  const formSubmitHanlder = (values) => {
    const data = {
      user: {
        phone_number: values?.phone_number,
      },
    };
    setLoader(true);

    headersPost(MINISTRY_API_ULRS.UPDATE_USER, data)
      .then((res) => {
        setLoader(false);
        if (res?.status === 200 && res?.data?.success) {
          setAlertOpen(true);
          setAlertMsg(res?.data?.message);
          setAlertIcon("success");
          setTimeout(() => {
            closeHandler();
          }, 100);
        } else {
          setAlertOpen(true);
          setAlertMsg(res?.data?.message);
          setAlertIcon("warning");
        }
      })
      .catch((err) => {
        setLoader(false);
        const { response } = err;
        if (response?.status === 401) {
          localStorage.clear();
          navigate(RoutesUrls?.root);
        } else {
          setAlertOpen(true);
          setAlertMsg(response?.statusText);
          setAlertIcon("error");
        }
      });
  };

  //life cycle

  useEffect(() => {
    user?.phone_number &&
      setFormValues((prev) => ({
        ...prev,
        phone_number: user?.phone_number,
      }));

    return () => {
      setFormValues(initialValue);
    };
  }, [user]);

  //close alert

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlertOpen(false);
  };

  //render

  return (
    <Dialog open={open} onClose={closeHandler} fullWidth>
      <DialogTitle sx={{ m: 0, p: 2 }}>
        <Typography
          fontWeight={"bold"}
          variant="h6"
          align="center"
          sx={{
            textDecoration: "underline",
          }}
        >
          Edit Phone Number
        </Typography>

        <IconButton
          aria-label="close"
          onClick={closeHandler}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Formik
          initialValues={formValues}
          onSubmit={formSubmitHanlder}
          validationSchema={phoneSchema}
          enableReinitialize
        >
          {({ values, touched, errors, handleChange, handleSubmit }) => (
            <Form onSubmit={handleSubmit} noValidate>
              <Box padding={{ xs: 2, sm: 3, md: 5 }}>
                <Grid
                  container
                  justifyContent={"space-around"}
                  spacing={2}
                  margin={"auto"}
                  maxWidth={250}
                >
                  <Grid container>
                    <TextField
                      variant="outlined"
                      size={"small"}
                      placeholder="Enter Phone Number"
                      type={"number"}
                      name="phone_number"
                      onChange={handleChange}
                      error={
                        touched?.phone_number && Boolean(errors?.phone_number)
                      }
                      helperText={touched?.phone_number && errors?.phone_number}
                      value={values.phone_number}
                      fullWidth
                      sx={{
                        [`.${outlinedInputClasses?.root}`]: {
                          borderRadius: theme.spacing(1),
                        },
                        [`.${formControlClasses?.root}`]: {
                          border: "none",
                        },
                      }}
                    />
                    <Grid
                      container
                      marginTop={5}
                      display={"flex"}
                      justifyContent={"center"}
                    >
                      <Button
                        variant="contained"
                        type="submit"
                        size="large"
                        margin={"auto"}
                        sx={{
                          borderRadius: "37px !important",
                          minWidth: "20%",
                        }}
                      >
                        Update Name
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </Box>
            </Form>
          )}
        </Formik>
      </DialogContent>
      <Backdrop
        sx={{
          zIndex: theme.zIndex.drawer + 1,
          color: theme.palette.primary.main,
        }}
        open={loader}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={alertOpen}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={alertIcon}>
          {alertMsg}
        </Alert>
      </Snackbar>
    </Dialog>
  );
};

export default EditPhoneModal;
